export default {
    methods: {
        checkPermission: function(aclList, action) {
            if(!aclList || !(action in aclList) || aclList[action] == null) return true;
            return this.$auth.check(aclList[action]);
        },
    }
};
